<template>
  <div>
    <el-card shadow="never" style="padding-bottom: 10px">
      <el-col :xs="12" :sm="12" :md="12" :lg="5" style="padding-top: 5pt">
        <span class="head-title">Manage Other Benefits Deduction ( {{ aStatusLabel }} )</span>
      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="6">
        <span><el-input v-debounce="getAll" :debounce-events="'keydown'" v-model="search" type="text" placeholder="search" ><i slot="suffix" class="el-input__icon el-icon-search"/></el-input></span>
      </el-col>
    </el-card>
    <el-row>
      <el-col :xs="24" :sm="24" :md="8" :lg="8">
        <el-card class="box-card">
          <el-alert
            :closable="false"
            title="Info"
            type="info"
            description="Select an employee to be updated"
            show-icon />
          <el-table
            v-loading="loading"
            ref="multipleTable"
            :data="personnel"
            :cell-class-name="setclass"
            :row-class-name="setrowclass"
            :header-cell-class-name="setheadclass"
            element-loading-text="Gathering data..."
            highlight-current-row
            height="520pt"
            style="width: 100%"
            @current-change="handleCurrentChange">
            <el-table-column prop="person_info.fullname" label="Fullname" />
            <el-table-column label="Salary">
              <template slot-scope="scope">
                {{ Number(scope.row.salary).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
              </template>
            </el-table-column>
            <!--el-table-column label="Others" width="100px">
              <template slot-scope="scope">
                {{ Number(scope.row.ben_total).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
              </template>
            </el-table-column-->
          </el-table>
          <div style="text-align: center;">
            <el-pagination :page-size="meta.per_page" :pager-count="7" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getAll"/>
          </div>
        </el-card>
      </el-col>
      <el-col v-if="allDeductionForm" :xs="12" :sm="12" :md="10" :lg="7">
        <el-card v-loading="loading" class="box-card">
          <div slot="header" class="clearfix" style="color: #0a8700;font-weight: 500">
            Add Deduction to All Personnel
          </div>
          <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="Deduction">
              <el-select v-model="form.deduction_id" filterable clearable placeholder="Select Benefits" @change="setBenefits">
                <el-option v-for="deduction in deductions" :key="deduction.id" :value="deduction.id" :label="deduction.desc">{{ deduction.desc }}</el-option>
              </el-select>
              <el-checkbox v-if="form.deduction_id" v-model="checked">Set all personnel deduction to in-active </el-checkbox>
            </el-form-item>
            <el-form-item v-if="!checked" label="Deducted To">
              <el-select v-model="form.benefit_id" filterable clearable placeholder="Select Benefits">
                <el-option
                  v-for="item in benefits"
                  :key="item.id"
                  :label="item.name + '(' + item.desc + ')'"
                  :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="form.deduction_id === 56 && !checked" label="Tax %">
              <el-input v-model="tax" class="amount" placeholder="Tax percentage %"/>
            </el-form-item>
            <el-form-item v-if="form.deduction_id !== 56 && !checked" label="Amount" prop="amount">
              <el-input :disabled="amountDis" v-model="form.amount" class="amount" placeholder="Amount"/>
            </el-form-item>
            <el-form-item>
              <el-button @click="handleClose">Cancel</el-button>
              <el-button type="primary" @click="save(true)">Confirm</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
      <el-col v-if="showDetails" :xs="24" :sm="24" :md="16" :lg="16">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="margin-top: 10px;">{{ currentRow.person_info.fullname }}</span>
            <span style="float: right;"><el-button type="success" size="small" @click="add"><i class="el-icon-plus" /> Add Deduction</el-button></span>
            <span style="float: right;margin-right: 20px">
              <el-select v-model="searchBen" filterable clearable size="small" placeholder="Select Benefits" @change="showDeduction">
                <el-option
                  v-for="item in benefitData"
                  :key="item.id"
                  :label="item.benefits.name + '(' + item.benefits.desc + ')'"
                  :value="item.id" />
              </el-select>
            </span>
          </div>
          <el-table
            v-loading="loading"
            ref="multipleTable"
            :data="otherBenefitDeductionData"
            height="400"
            size="small"
            style="width: 100%">
            <el-table-column
              width="50">
              <template slot-scope="scope">
                <el-checkbox :key="scope.row.id" :checked="scope.row.status===1" @change="changeStatus(scope.row.id, $event)" />
              </template>
            </el-table-column>
            <el-table-column prop="deductdesc" label="Deduction" />
            <el-table-column prop="amount" label="Amount" width="150px" align="center">
              <template slot-scope="scope">
                {{ Number(scope.row.amount).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
              </template>
            </el-table-column>
            <el-table-column width="100px" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.tax_percentage">{{ scope.row.tax_percentage }} %</span>
              </template>
            </el-table-column>
            <el-table-column label="Deducted To" >
              <template slot-scope="scope">
                {{ scope.row.name }} {{ scope.row.desc ? '(' + scope.row.desc + ')' : '' }}
              </template>
            </el-table-column>
            <el-table-column label="update" width="170px">
              <template slot-scope="scope">
                <el-button type="warning" size="small" @click="edit(scope.row)"><i class="el-icon-edit"/></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;">
            <el-pagination :page-size="meta0.per_page" :pager-count="7" :total="meta0.total" :current-page.sync="meta0.page" layout="total, prev, pager, next" @current-change="showDeduction"/>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="showDialog"
      :title="titleHeader"
      :before-close="handleClose"
      width="30%">
      <div>
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="Deduction">
            <el-select v-model="form.deduction_id" filterable clearable placeholder="Select Benefits" @change="setBenefits">
              <el-option v-for="deduction in deductions" :key="deduction.id" :value="deduction.id" :label="deduction.desc">{{ deduction.desc }}</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Deducted To">
            <el-select v-model="form.benefit_id" filterable clearable placeholder="Select Benefits" @change="setBenefits">
              <el-option
                v-for="item in benefitData"
                :key="item.id"
                :label="item.benefits.name + '(' + item.benefits.desc + ')'"
                :value="item.id" />
            </el-select>
          </el-form-item>
          <label v-if="form.deduction_id === 56" style="margin-left: 100px; color: #0a8700"> {{ calc }}</label>
          <el-form-item v-if="form.deduction_id === 56" label="Tax %">
            <el-input v-model="tax" class="amount" placeholder="Tax percentage %"/>
          </el-form-item>
          <el-form-item label="Amount" prop="amount">
            <el-input :disabled="amountDis" v-model="form.amount" class="amount" placeholder="Amount"/>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancel</el-button>
        <el-button type="primary" @click="save(false)">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Personnel } from '@/api/payroll/personnel'
import { EmpBenefits } from '@/api/payroll/empbenefits'
import SelectDeduction from '../../../views/layout/components/SelectDeduction'
import { Benefits } from '@/api/payroll/benefits'
import _ from 'lodash'
import { NotifyError, NotifySuccess } from '../../../helper/Helper'
import { Deduction } from '../../../api/payroll/deduction'

export default {
  name: 'OtherBenefitDeduction',
  components: {
    SelectDeduction
  },
  data() {
    return {
      checked: false,
      allDeductionForm: true,
      difTax: false,
      sel: 0,
      deductions: {},
      deductionupdate: false,
      form: {
        'deduction_id': '',
        'benefit_id': '',
        'amount': ''
      },
      titleHeader: 'Add Deduction',
      showDialog: false,
      meta: {
        page: 1
      },
      meta0: {
        page: 1
      },
      loading: false,
      personnel: [],
      roleACC: false,
      search: '',
      personnel_id: '',
      showDetails: false,
      otherBenefitDeductionData: [],
      currentRow: null,
      benefitData: [],
      amountForWHTax: 0,
      tax: null,
      amountDis: false,
      calc: '',
      obdid: null,
      isEdit: false,
      searchBen: null,
      benefits: [],
      tenure: parseInt(this.$store.getters.APStatus),
      aStatusLabel: null,
      campus_id: this.$store.getters.user.currentUser.personnel.department.campus_id
    }
  },
  watch: {
    tax: function() {
      this.calculateTax()
    }
  },
  created() {
    this.$store.dispatch('APStatus', this.$store.getters.APStatus)
    if (this.tenure === 3) { this.aStatusLabel = 'Permanent' }
    if (this.tenure === 2) { this.aStatusLabel = 'Contractual' }
    if (this.tenure === 1) { this.aStatusLabel = 'Casual' }
    this.checkRole()
    this.getAll()
    this.getDeductionList()
    Benefits({ per_page: 9999, term: null, type: 'report' }, 'get').then(res => {
      this.benefits = res.data.benefits
    }).catch(() => {})
    var self = this
    document.onkeydown = function(e) {
      var key = window.event.keyCode
      if (key === 38 && self.index > 0) {
        self.index -= 1
        self.setCurrent(self.index)
      }
      if (key === 40 && self.index < 11) {
        self.index += 1
        self.setCurrent(self.index)
      }
    }
  },
  methods: {
    getDeductionList() {
      Deduction({ per_page: 9999, notsettings: true }, 'get').then(res => {
        this.deductions = res.data.deduction
      }).catch(() => {})
    },
    handleClose() {
      this.showDialog = false
      this.tax = null
      this.calc = ''
      this.amountForWHTax = 0
      this.form = {
        'deduction_id': '',
        'benefit_id': '',
        'amount': ''
      }
    },
    calculateTax() {
      this.form.amount = (this.amountForWHTax * this.tax / 100)
      this.calc = 'Calculation: Amount (' + this.amountForWHTax + ')' + ' * tax percentage (' + this.tax + ')' + ' / 100'
    },
    setBenefits() {
      if (this.form.deduction_id === 56 && this.form.benefit_id) {
        const obj = this.benefitData.find(o => o.id === this.form.benefit_id)
        this.difTax = obj.benefits.tag === 1
        this.amountForWHTax = obj.amount
        this.amountDis = true
      } else {
        this.amountDis = false
        this.tax = null
        this.difTax = false
      }
    },
    getAll() {
      this.loading = true
      Personnel({ sort: true, term: this.search, astatus: 'Permanent', status: null, page: this.meta.page, honorarium: false, others: true, tenure: this.tenure, campus_id: this.campus_id }, 'get', '').then(res => {
        this.personnel = res.data.personnel
        this.meta = res.data.meta
        this.loading = false
      }).catch(error => {
        console.log(error)
      })
    },
    // setDeduction(id) {
    //   this.form.deduction_id = id
    // },
    setrowclass({ row, rowIndex }) {
      return 'personnel'
    },
    setclass(row) {
      if (row.columnIndex === 1) {
        return 'cell_' + row.columnIndex
      }
      if (row.columnIndex === 2) {
        return 'cell_' + row.columnIndex
      }
    },
    setheadclass(row) {
      if (row.columnIndex === 1) {
        return 'personnel ' + 'header_' + row.columnIndex
      }
    },
    handleCurrentChange: _.debounce(function(val) {
      if (val) {
        this.personnel_id = val.id
        this.currentRow = val
        this.showDetails = true
        this.allDeductionForm = false
        this.showDeduction()
        this.getOtherBenefitAdded()
        this.getDeductionList()
      }
    }, 500),
    showDeduction() {
      this.loading = true
      EmpBenefits({ personnel_id: this.personnel_id, page: this.meta0.page, searchBen: this.searchBen, tenure: this.tenure }, 'post', 'getOtherBenefitDeduction').then(res => {
        this.otherBenefitDeductionData = res.data
        this.loading = false
      }).catch(error => {
        console.log(error)
      })
    },
    getOtherBenefitAdded() {
      EmpBenefits({ personnel_id: this.personnel_id }, 'post', 'getOtherBenefitAdded').then(res => {
        this.benefitData = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    add() {
      this.showDialog = true
      this.tax = null
      this.calc = ''
      this.amountForWHTax = 0
      this.obdid = null
      this.form = {
        'deduction_id': '',
        'benefit_id': '',
        'amount': ''
      }
    },
    edit(row) {
      this.showDialog = true
      this.isEdit = true
      this.obdid = row.id
      this.form.benefit_id = row.benefit_id
      this.form.amount = row.amount
      this.form.deduction_id = row.deduction_id
      if (row.tax_percentage) {
        this.tax = row.tax_percentage
        this.setBenefits()
      }
    },
    save(label) {
      let msg = ''
      if (this.obdid) {
        msg = 'Update Other Benefit Deduction. Continue?'
      } else {
        msg = 'Add Other Benefit Deduction. Continue?'
      }
      if (label) {
        if (this.form.deduction_id === 56) {
          this.form.amount = 10
        }
        if (this.checked) {
          msg = 'This function will update other Benefits deduction to In-active. Continue?'
        } else {
          msg = 'This function will add other Benefits deduction to all active employee. Continue?'
        }
      }
      this.$confirm(msg, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.form.all = label ? 1 : 0
        this.form.tax = this.tax
        this.form.obdID = this.obdid
        this.form.personnel_id = this.personnel_id
        this.form.tenure = this.tenure
        this.form.allU = this.checked
        this.form.campus_id = this.campus_id
        EmpBenefits(this.form, 'post', 'AddOtherBenefitDeduction').then(res => {
          if (res.data.status === false) {
            NotifyError(res.data.message)
          } else {
            NotifySuccess(res.data.message)
            this.showDeduction()
            this.handleClose()
          }
          this.loading = false
        }).catch(error => {
          console.log(error)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Adding Other Deduction Benefits Cancel'
        })
      })
    },
    changeStatus(id, event) {
      EmpBenefits({ id: id, active: event }, 'post', 'setActiveOtherBenefitDeduction').then(res => {
        if (event) {
          this.$message({ message: 'Activated.', type: 'success' })
        } else {
          this.$message({ message: 'Deactivated.', type: 'warning' })
        }
        this.showDeduction()
      }).catch(error => {
        console.log(error)
      })
    },
    checkRole() {
      var self = this
      this.$store.getters.user.currentUser.roles.forEach(function(value, key) {
        if (value.name === 'payroll_accounting') {
          self.roleACC = true
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
